import { SelectionTemplateTaintEffect } from '@cast/types';

import {
  ProvisionNodesCloudConfigurationFormValues,
  ProvisionNodesCustomConfigurationFormValues,
} from './types';

/**
 * Maximum number of shared clients per physical GPU for time-slicing.
 * Matches the documented platform limit.
 */
export const MAX_GPU_TIME_SLICING_REPLICAS = 48;

/**
 * Pattern for a MIG partition size label (e.g. `1g.5gb`, `2g.48gb-me`).
 * Matches a single compute slice digit 1-7, the literal `g.`, one or more
 * memory digits, the literal `gb`, and an optional media/graphics suffix
 * (`+me`, `+me.all`, `+gfx`, `-me`).
 */
export const MIG_PARTITION_SIZE_PATTERN =
  /^[1-7]g\.\d+gb(\+me(\.all)?|\+gfx|-me)?$/;

export const MIG_PARTITION_SIZE_PATTERN_MESSAGE =
  'Partition size must follow the pattern Xg.Ygb with an optional suffix (e.g. 1g.5gb, 1g.5gb+me)';

export const PROVISION_NODES_CUSTOM_INITIAL_VALUES: ProvisionNodesCustomConfigurationFormValues =
  {
    shouldTaint: false,
    shouldUseCustomLabels: false,
    _customTaints: [
      {
        key: 'scheduling.cast.ai/node-template',
        value: '',
        effect: SelectionTemplateTaintEffect.NoSchedule,
      },
    ],
    _customLabels: [
      {
        key: '',
        value: '',
      },
    ],
    replicas: undefined,
    partitionSize: undefined,
  };

export const PROVISION_NODES_CLOUD_INITIAL_VALUES: ProvisionNodesCloudConfigurationFormValues =
  {
    name: undefined,
    instanceType: undefined,
    availabilityZone: undefined,
    edgeConfigurationId: undefined,
    resourceOffering: 'on-demand',
    gpuType: undefined,
    gpuCount: undefined,
    replicas: undefined,
    partitionSize: undefined,
    bootDiskGib: undefined,
    shouldTaint: false,
    shouldUseCustomLabels: false,
    deleteProtection: false,
    _customTaints: [
      {
        key: 'scheduling.cast.ai/node-template',
        value: '',
        effect: SelectionTemplateTaintEffect.NoSchedule,
      },
    ],
    _customLabels: [
      {
        key: '',
        value: '',
      },
    ],
  };
